import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import { Login } from './components/Login';
import { isAuthenticated, clearAuth } from './services/auth';
import './custom.css';
import './bia.css';

export default function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    setAuthenticated(isAuthenticated());
    setChecking(false);

    const handleUnauthorized = () => setAuthenticated(false);
    window.addEventListener('sibilla:unauthorized', handleUnauthorized);
    return () => window.removeEventListener('sibilla:unauthorized', handleUnauthorized);
  }, []);

  const handleLogin = () => setAuthenticated(true);

  const handleLogout = () => {
    clearAuth();
    setAuthenticated(false);
  };


  if (checking) {
    return null;
  }

  if (!authenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Layout onLogout={handleLogout}>
      <Routes>
        {AppRoutes.map((route, index) => {
          const { element, ...rest } = route;
          return <Route key={index} {...rest} element={element} />;
        })}
      </Routes>
    </Layout>
  );
}
